<template>
  <ul class="navbar-nav mb-2 mb-lg-0">
    <li class="nav-item dropdown">
      <PvButton label="MENU" class="nav-link dropdown-toggle text-white" href="#" id="navbarDropdownMenuLink" @click="showMenu" role="button" aria-haspopup="true" aria-expanded="false" />
      <Menu :model="menuItems" popup ref="menu" id="navbarDropdownMenuLink">
        <template #item="{ item, props }">
          <router-link v-if="item.route && !/^https?:\/\//.test(item.route)" :to="item.route" v-slot="{ href, navigate }" custom>
            <a :href="href" :class="buttonClass" v-bind="props.action" @click="navigate">{{ item.label }}</a>
          </router-link>
          <a
            v-else-if="item.route && /^https?:\/\//.test(item.route)"
            :href="item.route"
            :class="buttonClass"
            v-bind="props.action"
            target="_blank"
            rel="noopener"
          >{{ item.label }}</a>
          <a v-else-if="item.command" :class="buttonClass" @click="item.command" v-bind="props.action">{{ item.label }}</a>
          <hr v-else-if="item.separator" class="my-1" />
        </template>
      </Menu>
    </li>
  </ul>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { ref, computed } from 'vue';

// Components
import Menu from 'primevue/menu';

// Composables


// Stores
import { useAuthStore } from '@/stores/authStore';

// Constants and Utils
import { ORGANIZATION_TYPES, HELP_URL } from '@/utils/constants';
import { ROUTES, HCE_ROUTES, PROGRAM_ROUTES } from '@/router/routeConstants';

// ===============================
// PROPS & EMITS
// ===============================


// ===============================
// COMPOSABLES & STORES
// ===============================
const store = useAuthStore();

// ===============================
// REACTIVE STATE
// ===============================
const menu = ref(null);


// ===============================
// CONSTANTS
// ===============================
const buttonClass = 'dropdown-item py-1 pointer';
const programMenuItems = [
  { label: 'Home', route: ROUTES.HOME.fullPath },
  { label: 'My Department', route: PROGRAM_ROUTES.MY_DEPARTMENT.fullPath },
  { separator: true },
  { label: 'Registration Approvals', route: PROGRAM_ROUTES.REGISTRATION_APPROVALS.fullPath },
  { label: 'Registered Organizations', route: PROGRAM_ROUTES.ORGANIZATIONS.fullPath },
  { separator: true },
  { label: 'Review Annual Reports', route: PROGRAM_ROUTES.ANNUAL_REPORTS.fullPath },
  { label: 'Review HCE Transactions', route: PROGRAM_ROUTES.HCES.fullPath },
  { label: 'Review Reporting Exceptions', route: PROGRAM_ROUTES.REPORTING_EXCEPTIONS.fullPath },
  { separator: true },
  { label: 'Conversations', route: ROUTES.CONVERSATIONS.fullPath },
  { separator: true },
  { label: 'Help', route: HELP_URL },
  { separator: true },
  { label: 'Sign Out', command: () => store.logout() }
];


const hceUserMenuItems = [
  { label: 'Home', route: ROUTES.HOME.fullPath },
  { separator: true },
  { label: 'Conversations', route: ROUTES.CONVERSATIONS.fullPath },
  { separator: true },
  { label: 'Help', route: HELP_URL },
  { separator: true },
  { label: 'Sign Out', command: () => store.logout() }
];

// ===============================
// COMPUTED PROPERTIES
// ===============================
const showHceMenuItem = computed(() => {
  return store.user.primaryOrganizationTypes &&
    (store.user.primaryOrganizationTypes.includes(ORGANIZATION_TYPES.DI) || store.user.primaryOrganizationTypes.includes(ORGANIZATION_TYPES.FOSC));
});

const userMenuItems = computed(() => {
  const items = [
    { label: 'Home', route: ROUTES.HOME.fullPath },
    { label: 'My Organization', route: ROUTES.MY_ORGANIZATION.fullPath },
    { separator: true },
    { label: 'Annual Reports', route: ROUTES.ANNUAL_REPORTS.fullPath },
  ];

  if (showHceMenuItem.value) {
    items.push(
      { label: 'HCE Transactions', route: HCE_ROUTES.TRANSACTIONS.fullPath }
    );
  }

  items.push(
    { separator: true },
    { label: 'Conversations', route: ROUTES.CONVERSATIONS.fullPath },
    { separator: true },
    { label: 'Help', route: HELP_URL },
    { separator: true },
    { label: 'Sign Out', command: () => store.logout() }
  );

  return items;
});

const menuItems = computed(() => {
  return store.user.isAdminUser ? programMenuItems : store.user.isHceOnlyUser ? hceUserMenuItems : userMenuItems.value;
});

// ===============================
// METHODS
// ===============================
const showMenu = (event) => {
  menu.value?.toggle(event);
};

// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================


// ===============================
// EXPOSE
// ===============================


</script>

